export enum EvntGrp {
  EVNT_GRP_PJ_010_001 = "1", // プロジェクト起案
  EVNT_GRP_PJ_010_002 = "2", // 要件ヒアリングおよび見積を行うFRメンバー決定
  EVNT_GRP_PJ_010_003 = "3", // 見積結果の確認依頼
  EVNT_GRP_PJ_010_004 = "4", // 見積結果確認し承認
  EVNT_GRP_PJ_010_005 = "5", // 見積結果確認し却下
  EVNT_GRP_PJ_010_006 = "6", // 再見積もりを行うため、PJT計画チケットを見積作成中に戻す
  EVNT_GRP_PJ_010_007 = "7", // プロジェクト計画承認依頼
  EVNT_GRP_PJ_010_008 = "8", // プロジェクト計画承認し、計画を完了させる
  EVNT_GRP_PJ_010_009 = "9", // プロジェクト計画却下
  EVNT_GRP_PJ_010_010 = "10", // プロジェクト計画承認依頼取り下げ
  EVNT_GRP_PJ_020_001 = "11", // プロジェクトに関わるすべてのステークホルダーをアサイン
  EVNT_GRP_PJ_020_002 = "12", // プロジェクト開始宣言
  EVNT_GRP_PJ_020_003 = "13", // プロジェクト手動完了
  EVNT_GRP_IF_010_001 = "14", // Src IF属性入力レビュー依頼
  EVNT_GRP_IF_010_002 = "15", // IF属性設計レビュー
  EVNT_GRP_IF_010_003 = "16", // Src IF属性入力レビュー取り下げ
  EVNT_GRP_IF_010_004 = "17", // Src IF属性入力承認後に承認を引戻す
  EVNT_GRP_IF_010_006 = "18", // Src IF属性値を再入力するため、IF属性入力チケットを設計中に戻す
  EVNT_GRP_IF_020_001 = "19", // IF定義検証環境移送チケット更新
  EVNT_GRP_IF_020_002 = "20", // IF検証環境移送リクエストレビュー依頼
  EVNT_GRP_IF_020_003 = "21", // IF検証環境移送リクエスト承認
  EVNT_GRP_IF_020_004 = "22", // IF検証環境移送リクエスト否認
  EVNT_GRP_IF_020_005 = "23", // IF検証環境移送リクエスト破棄
  EVNT_GRP_IF_020_006 = "24", // 移送処理対象IF検証移送チケットをロックする
  EVNT_GRP_IF_020_007 = "25", // リトライ回数規定内でIF検証移送失敗時
  EVNT_GRP_IF_020_008 = "26", // IF検証移送のリトライ移送時
  EVNT_GRP_IF_020_009 = "27", // リトライ回数規定超過でIF検証移送失敗時
  EVNT_GRP_IF_020_010 = "28", // IF検証移送成功時
  EVNT_GRP_IF_020_011 = "29", // IF検証環境移送を引戻する
  EVNT_GRP_IF_020_012 = "30", // IF検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_IF_020_013 = "31", // IF検証環境移送の取消
  EVNT_GRP_IF_020_014 = "32", // 【取消】IF検証環境移送リクエスト承認
  EVNT_GRP_IF_020_015 = "33", // 【取消】IF検証環境移送リクエスト否認
  EVNT_GRP_IF_020_016 = "34", // 【取消】IF検証環境移送リクエスト破棄
  EVNT_GRP_IF_020_017 = "35", // 【取消】移送処理対象IF検証移送チケットをロックする
  EVNT_GRP_IF_020_018 = "36", // 【取消】リトライ回数規定内でIF検証移送失敗時
  EVNT_GRP_IF_020_019 = "37", // 【取消】IF検証移送のリトライ移送時
  EVNT_GRP_IF_020_020 = "38", // 【取消】リトライ回数規定超過でIF検証移送失敗時
  EVNT_GRP_IF_020_021 = "39", // 【取消】IF取消検証移送成功時
  EVNT_GRP_IF_020_022 = "40", // 【取消】IF検証環境移送を引戻する
  EVNT_GRP_IF_020_023 = "41", // 【取消】IF検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_IF_030_001 = "42", // IF定義本番環境移送チケット更新
  EVNT_GRP_IF_030_002 = "43", // IF要件明細の本番環境移送リクエストレビュー依頼
  EVNT_GRP_IF_030_003 = "44", // IF要件明細の本番環境移送リクエスト承認
  EVNT_GRP_IF_030_004 = "45", // IF要件明細の本番環境移送リクエスト否認
  EVNT_GRP_IF_030_005 = "46", // IF要件明細の本番環境移送リクエスト破棄
  EVNT_GRP_IF_030_006 = "47", // IF本番移送処理対象としてロックする
  EVNT_GRP_IF_030_007 = "48", // リトライ回数規定内でIF本番移送失敗時
  EVNT_GRP_IF_030_008 = "49", // IF本番移送のリトライ移送時
  EVNT_GRP_IF_030_009 = "50", // リトライ回数規定超過でIF本番移送失敗時
  EVNT_GRP_IF_030_010 = "51", // IF本番移送成功時
  EVNT_GRP_IF_030_011 = "52", // IF本番環境移送を引戻する
  EVNT_GRP_IF_030_012 = "53", // IF本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_IF_030_013 = "54", // IF本番環境移送の取消
  EVNT_GRP_IF_030_014 = "55", // 【取消】IF本番環境移送リクエスト承認
  EVNT_GRP_IF_030_015 = "56", // 【取消】IF本番環境移送リクエスト否認
  EVNT_GRP_IF_030_016 = "57", // 【取消】IF本番環境移送リクエスト破棄
  EVNT_GRP_IF_030_017 = "58", // 【取消】IF本番移送処理対象としてロックする
  EVNT_GRP_IF_030_018 = "59", // 【取消】リトライ回数規定内でIF本番移送失敗時
  EVNT_GRP_IF_030_019 = "60", // 【取消】IF本番移送の取消リトライ移送時
  EVNT_GRP_IF_030_020 = "61", // 【取消】リトライ回数規定超過で取消移送失敗時
  EVNT_GRP_IF_030_021 = "62", // 【取消】IF本番取消移送成功時
  EVNT_GRP_IF_030_022 = "63", // 【取消】IF本番環境移送承認後に承認を引戻する
  EVNT_GRP_IF_030_023 = "64", // 【取消】IF本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PJ_030_001 = "65", // コンポーネントプロジェクト起票
  EVNT_GRP_PJ_030_002 = "66", // コンポーネントプロジェクト開始宣言
  EVNT_GRP_PJ_030_003 = "67", // コンポーネントプロジェクト実行差戻
  EVNT_GRP_PJ_030_004 = "68", // コンポーネント設計チケット作成
  EVNT_GRP_PJ_030_005 = "69", // コンポーネント検証移送チケット作成
  EVNT_GRP_PJ_030_006 = "70", // コンポーネント本番移送チケット作成
  EVNT_GRP_PJ_030_007 = "71", // プロジェクト手動完了
  EVNT_GRP_PT_010_001 = "72", // Component設計レビュー依頼
  EVNT_GRP_PT_010_002 = "73", // Component設計レビュー承認
  EVNT_GRP_PT_010_003 = "74", // Component設計レビュー否認
  EVNT_GRP_PT_010_004 = "75", // Component設計レビュー取り下げ
  EVNT_GRP_PT_010_005 = "76", // Component設計レビュー承認後に承認を引戻す
  EVNT_GRP_PT_010_006 = "77", // Component再設計を行うため、Component設計チケットステータスを設計中に戻す
  EVNT_GRP_PT_020_001 = "78", // Component検証移送チケット更新
  EVNT_GRP_PT_020_002 = "79", // Component検証環境移送リクエストレビュー依頼
  EVNT_GRP_PT_020_003 = "80", // Component検証環境移送リクエスト承認
  EVNT_GRP_PT_020_004 = "81", // Component検証環境移送リクエスト否認
  EVNT_GRP_PT_020_005 = "82", // Component検証環境移送リクエスト破棄
  EVNT_GRP_PT_020_006 = "83", // Component検証環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_020_007 = "84", // リトライ回数規定内でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_024 = "85", // Component検証環境移送リトライ移送時
  EVNT_GRP_PT_020_008 = "86", // リトライ回数規定超過でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_009 = "87", // Component検証環境移送の移送成功時
  EVNT_GRP_PT_020_010 = "88", // Component検証環境移送承認後に承認を引戻する
  EVNT_GRP_PT_020_011 = "89", // Component検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_020_012 = "90", // Component検証環境移送の取消
  EVNT_GRP_PT_020_013 = "91", // 【取消】Component検証環境移送リクエスト承認
  EVNT_GRP_PT_020_014 = "92", // 【取消】Component検証環境移送リクエスト否認
  EVNT_GRP_PT_020_015 = "93", // 【取消】Component検証環境移送リクエスト破棄
  EVNT_GRP_PT_020_016 = "94", // 【取消】Component検証環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_020_017 = "95", // 【取消】リトライ回数規定内でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_018 = "96", // 【取消】Component検証環境移送リトライ移送時
  EVNT_GRP_PT_020_019 = "97", // 【取消】リトライ回数規定超過でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_020 = "98", // 【取消】Component検証環境移送の移送成功時
  EVNT_GRP_PT_020_021 = "99", // 【取消】Component検証環境移送を引戻する
  EVNT_GRP_PT_020_022 = "100", // 【取消】Component検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_030_001 = "101", // Component本番移送チケット更新
  EVNT_GRP_PT_030_002 = "102", // Component本番環境移送リクエストレビュー依頼
  EVNT_GRP_PT_030_003 = "103", // Component本番環境移送リクエスト承認
  EVNT_GRP_PT_030_004 = "104", // Component本番環境移送リクエスト否認
  EVNT_GRP_PT_030_005 = "105", // Component本番環境移送リクエスト破棄
  EVNT_GRP_PT_030_006 = "106", // Component本番環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_030_007 = "107", // リトライ回数規定内でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_008 = "108", // Component本番環境移送リトライ移送時
  EVNT_GRP_PT_030_009 = "109", // リトライ回数規定超過でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_010 = "110", // Component本番環境移送の移送成功時
  EVNT_GRP_PT_030_011 = "111", // Component本番環境移送承認後に承認を引戻する
  EVNT_GRP_PT_030_012 = "112", // Component本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_030_013 = "113", // Component本番環境移送の取消
  EVNT_GRP_PT_030_014 = "114", // 【取消】Component本番環境移送リクエスト承認
  EVNT_GRP_PT_030_015 = "115", // 【取消】Component本番環境移送リクエスト否認
  EVNT_GRP_PT_030_016 = "116", // 【取消】Component本番環境移送リクエスト破棄
  EVNT_GRP_PT_030_017 = "117", // 【取消】Component本番環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_030_018 = "118", // 【取消】リトライ回数規定内でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_019 = "119", // 【取消】Component本番環境移送リトライ移送時
  EVNT_GRP_PT_030_020 = "120", // 【取消】リトライ回数規定超過でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_021 = "121", // 【取消】Component本番環境移送の移送成功時
  EVNT_GRP_PT_030_022 = "122", // 【取消】Component本番環境移送承認後に承認を引戻する
  EVNT_GRP_PT_030_023 = "123", // 【取消】Component本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_040_001 = "143", // STGインフラ構築チケット作成:DIPAPP
  EVNT_GRP_PT_040_101 = "144", // STGインフラ構築チケット実行:DIPAPP
  EVNT_GRP_PT_040_201 = "145", // STGインフラ構築チケット完了:DIPAPP
  EVNT_GRP_PT_040_301 = "146", // STGインフラ構築チケットキャンセル:DIPAPP
  EVNT_GRP_PT_050_001 = "147", // 副STGインフラ構築チケット作成:DIPAPP
  EVNT_GRP_PT_050_101 = "148", // 副STGインフラ構築チケット実行:DIPAPP
  EVNT_GRP_PT_050_201 = "149", // 副STGインフラ構築チケット完了:DIPAPP
  EVNT_GRP_PT_050_301 = "150", // 副STGインフラ構築チケットキャンセル:DIPAPP
  EVNT_GRP_PT_060_001 = "151", // PRDインフラ構築チケット作成:DIPAPP
  EVNT_GRP_PT_060_101 = "152", // PRDインフラ構築チケット実行:DIPAPP
  EVNT_GRP_PT_060_201 = "153", // PRDインフラ構築チケット完了:DIPAPP
  EVNT_GRP_PT_060_301 = "154", // PRDインフラ構築チケットキャンセル:DIPAPP
  EVNT_GRP_PJ_010_101 = "200", // GOD IFプロジェクト計画起案
  EVNT_GRP_PJ_010_102 = "201", // GOD IFプロジェクト計画更新
  EVNT_GRP_PJ_020_008 = "202", // GOD IFプロジェクト実行起案
  EVNT_GRP_PJ_020_009 = "203", // GOD IFプロジェクト実行開始
  EVNT_GRP_PJ_020_010 = "204", // 【GOD】Src IF属性入力チケット作成
  EVNT_GRP_PJ_020_011 = "205", // 【GOD】Dst IF属性入力チケット作成
  EVNT_GRP_PJ_020_012 = "206", // 【GOD】IF検証移送チケット作成
  EVNT_GRP_PJ_020_013 = "207", // 【GOD】IF本番移送チケット作成
  EVNT_GRP_PJ_020_014 = "208", // 【GOD】IFプロジェクト手動完了
  EVNT_GRP_IF_010_009 = "209", // 【GOD】IF属性入力チケット更新
  EVNT_GRP_IF_020_101 = "210", // 【GOD】IF定義検証環境移送チケット更新
  EVNT_GRP_IF_020_102 = "211", // 【GOD】IF検証環境移送リクエストレビュー依頼
  EVNT_GRP_IF_020_104 = "212", // 【GOD】IF検証環境移送リクエスト承認
  EVNT_GRP_IF_020_106 = "213", // 【GOD】IF検証環境移送リクエスト否認
  EVNT_GRP_IF_020_108 = "214", // 【GOD】IF検証環境移送リクエスト破棄
  EVNT_GRP_IF_020_116 = "215", // 【GOD】移送処理対象IF検証移送チケットをロックする
  EVNT_GRP_IF_020_117 = "216", // 【GOD】リトライ回数規定内でIF検証移送失敗時
  EVNT_GRP_IF_020_119 = "217", // 【GOD】IF検証移送のリトライ移送時
  EVNT_GRP_IF_020_120 = "218", // 【GOD】リトライ回数規定超過でIF検証移送失敗時
  EVNT_GRP_IF_020_122 = "219", // 【GOD】IF検証移送成功時
  EVNT_GRP_IF_020_124 = "230", // 【GOD】IF検証環境移送を引戻する
  EVNT_GRP_IF_020_130 = "231", // 【GOD】IF検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_IF_020_132 = "232", // 【GOD】IF検証環境移送の取消
  EVNT_GRP_IF_020_134 = "233", // 【GOD】【取消】IF検証環境移送リクエスト承認
  EVNT_GRP_IF_020_136 = "234", // 【GOD】【取消】IF検証環境移送リクエスト否認
  EVNT_GRP_IF_020_138 = "235", // 【GOD】【取消】IF検証環境移送リクエスト破棄
  EVNT_GRP_IF_020_146 = "236", // 【GOD】【取消】移送処理対象IF検証移送チケットをロックする
  EVNT_GRP_IF_020_147 = "237", // 【GOD】【取消】リトライ回数規定内でIF検証移送失敗時
  EVNT_GRP_IF_020_149 = "238", // 【GOD】【取消】IF検証移送のリトライ移送時
  EVNT_GRP_IF_020_150 = "239", // 【GOD】【取消】リトライ回数規定超過でIF検証移送失敗時
  EVNT_GRP_IF_020_152 = "240", // 【GOD】【取消】IF取消検証移送成功時
  EVNT_GRP_IF_020_154 = "241", // 【GOD】【取消】IF検証環境移送を引戻する
  EVNT_GRP_IF_020_160 = "242", // 【GOD】【取消】IF検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_IF_030_101 = "243", // 【GOD】IF定義本番環境移送チケット更新
  EVNT_GRP_IF_030_102 = "244", // 【GOD】IF要件明細の本番環境移送リクエストレビュー依頼
  EVNT_GRP_IF_030_103 = "245", // 【GOD】IF要件明細の本番環境移送リクエスト承認
  EVNT_GRP_IF_030_104 = "246", // 【GOD】IF要件明細の本番環境移送リクエスト否認
  EVNT_GRP_IF_030_105 = "247", // 【GOD】IF要件明細の本番環境移送リクエスト破棄
  EVNT_GRP_IF_030_109 = "248", // 【GOD】IF本番移送処理対象としてロックする
  EVNT_GRP_IF_030_110 = "249", // 【GOD】リトライ回数規定内でIF本番移送失敗時
  EVNT_GRP_IF_030_111 = "250", // 【GOD】IF本番移送のリトライ移送時
  EVNT_GRP_IF_030_112 = "251", // 【GOD】リトライ回数規定超過でIF本番移送失敗時
  EVNT_GRP_IF_030_113 = "252", // 【GOD】IF本番移送成功時
  EVNT_GRP_IF_030_114 = "253", // 【GOD】IF本番環境移送を引戻する
  EVNT_GRP_IF_030_117 = "254", // 【GOD】IF本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_IF_030_118 = "255", // 【GOD】IF本番環境移送の取消
  EVNT_GRP_IF_030_119 = "256", // 【GOD】【取消】IF本番環境移送リクエスト承認
  EVNT_GRP_IF_030_120 = "257", // 【GOD】【取消】IF本番環境移送リクエスト否認
  EVNT_GRP_IF_030_121 = "258", // 【GOD】【取消】IF本番環境移送リクエスト破棄
  EVNT_GRP_IF_030_125 = "259", // 【GOD】【取消】IF本番移送処理対象としてロックする
  EVNT_GRP_IF_030_126 = "260", // 【GOD】【取消】リトライ回数規定内でIF本番移送失敗時
  EVNT_GRP_IF_030_127 = "261", // 【GOD】【取消】IF本番移送の取消リトライ移送時
  EVNT_GRP_IF_030_128 = "262", // 【GOD】【取消】リトライ回数規定超過で取消移送失敗時
  EVNT_GRP_IF_030_129 = "263", // 【GOD】【取消】IF本番取消移送成功時
  EVNT_GRP_IF_030_130 = "264", // 【GOD】【取消】IF本番環境移送承認後に承認を引戻する
  EVNT_GRP_IF_030_133 = "265", // 【GOD】【取消】IF本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PJ_030_008 = "300", // GODコンポーネントプロジェクト起票
  EVNT_GRP_PJ_030_009 = "301", // GODコンポーネントプロジェクト開始宣言
  EVNT_GRP_PJ_030_010 = "302", // 【GOD】コンポーネント設計チケット作成
  EVNT_GRP_PJ_030_011 = "303", // 【GOD】コンポーネント検証移送チケット作成
  EVNT_GRP_PJ_030_012 = "304", // 【GOD】コンポーネント本番移送チケット作成
  EVNT_GRP_PJ_020_015 = "305", // 【GOD】コンポーネントプロジェクト手動完了
  EVNT_GRP_PT_010_007 = "306", // 【GOD】Component設計チケット更新
  EVNT_GRP_PT_020_101 = "307", // 【GOD】Component検証移送チケット更新
  EVNT_GRP_PT_020_102 = "308", // 【GOD】Component検証環境移送リクエストレビュー依頼
  EVNT_GRP_PT_020_103 = "309", // 【GOD】Component検証環境移送リクエスト承認
  EVNT_GRP_PT_020_104 = "310", // 【GOD】Component検証環境移送リクエスト否認
  EVNT_GRP_PT_020_105 = "311", // 【GOD】Component検証環境移送リクエスト破棄
  EVNT_GRP_PT_020_109 = "312", // 【GOD】Component検証環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_020_110 = "313", // 【GOD】リトライ回数規定内でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_162 = "314", // 【GOD】Component検証環境移送リトライ移送時
  EVNT_GRP_PT_020_111 = "315", // 【GOD】リトライ回数規定超過でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_112 = "316", // 【GOD】Component検証環境移送の移送成功時
  EVNT_GRP_PT_020_113 = "317", // 【GOD】Component検証環境移送承認後に承認を引戻する
  EVNT_GRP_PT_020_116 = "318", // 【GOD】Component検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_020_117 = "319", // 【GOD】Component検証環境移送の取消
  EVNT_GRP_PT_020_118 = "320", // 【GOD】【取消】Component検証環境移送リクエスト承認
  EVNT_GRP_PT_020_119 = "321", // 【GOD】【取消】Component検証環境移送リクエスト否認
  EVNT_GRP_PT_020_120 = "322", // 【GOD】【取消】Component検証環境移送リクエスト破棄
  EVNT_GRP_PT_020_124 = "323", // 【GOD】【取消】Component検証環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_020_125 = "324", // 【GOD】【取消】リトライ回数規定内でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_126 = "325", // 【GOD】【取消】Component検証環境移送リトライ移送時
  EVNT_GRP_PT_020_127 = "326", // 【GOD】【取消】リトライ回数規定超過でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_128 = "327", // 【GOD】【取消】Component検証環境移送の移送成功時
  EVNT_GRP_PT_020_129 = "328", // 【GOD】【取消】Component検証環境移送を引戻する
  EVNT_GRP_PT_020_132 = "329", // 【GOD】【取消】Component検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_030_101 = "330", // 【GOD】Component本番移送チケット更新
  EVNT_GRP_PT_030_102 = "331", // 【GOD】Component本番環境移送リクエストレビュー依頼
  EVNT_GRP_PT_030_103 = "332", // 【GOD】Component本番環境移送リクエスト承認
  EVNT_GRP_PT_030_104 = "333", // 【GOD】Component本番環境移送リクエスト否認
  EVNT_GRP_PT_030_105 = "334", // 【GOD】Component本番環境移送リクエスト破棄
  EVNT_GRP_PT_030_109 = "335", // 【GOD】Component本番環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_030_110 = "336", // 【GOD】リトライ回数規定内でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_111 = "337", // 【GOD】Component本番環境移送リトライ移送時
  EVNT_GRP_PT_030_112 = "338", // 【GOD】リトライ回数規定超過でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_113 = "339", // 【GOD】Component本番環境移送の移送成功時
  EVNT_GRP_PT_030_114 = "340", // 【GOD】Component本番環境移送承認後に承認を引戻する
  EVNT_GRP_PT_030_117 = "341", // 【GOD】Component本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_030_118 = "342", // 【GOD】Component本番環境移送の取消
  EVNT_GRP_PT_030_119 = "343", // 【GOD】【取消】Component本番環境移送リクエスト承認
  EVNT_GRP_PT_030_120 = "344", // 【GOD】【取消】Component本番環境移送リクエスト否認
  EVNT_GRP_PT_030_121 = "345", // 【GOD】【取消】Component本番環境移送リクエスト破棄
  EVNT_GRP_PT_030_125 = "346", // 【GOD】【取消】Component本番環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_030_126 = "347", // 【GOD】【取消】リトライ回数規定内でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_127 = "348", // 【GOD】【取消】Component本番環境移送リトライ移送時
  EVNT_GRP_PT_030_128 = "349", // 【GOD】【取消】リトライ回数規定超過でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_129 = "350", // 【GOD】【取消】Component本番環境移送の移送成功時
  EVNT_GRP_PT_030_130 = "351", // 【GOD】【取消】Component本番環境移送承認後に承認を引戻する
  EVNT_GRP_PT_030_133 = "352", // 【GOD】【取消】Component本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PJ_010_103 = "400", // 無名 IFプロジェクト計画起案
  EVNT_GRP_PJ_010_104 = "401", // 無名 IFプロジェクト計画更新
  EVNT_GRP_PJ_020_016 = "402", // 無名 IFプロジェクト実行起案
  EVNT_GRP_PJ_020_017 = "403", // 無名 IFプロジェクト実行開始
  EVNT_GRP_PJ_020_018 = "404", // 【無名】Src IF属性入力チケット作成
  EVNT_GRP_PJ_020_019 = "405", // 【無名】Dst IF属性入力チケット作成
  EVNT_GRP_PJ_020_020 = "406", // 【無名】IF検証移送チケット作成
  EVNT_GRP_PJ_020_021 = "407", // 【無名】IF本番移送チケット作成
  EVNT_GRP_PJ_020_022 = "408", // 【無名】IFプロジェクト手動完了
  EVNT_GRP_IF_010_017 = "409", // 【無名】IF属性入力チケット更新
  EVNT_GRP_IF_020_201 = "410", // 【無名】IF定義検証環境移送チケット更新
  EVNT_GRP_IF_020_202 = "411", // 【無名】IF検証環境移送リクエストレビュー依頼
  EVNT_GRP_IF_020_204 = "412", // 【無名】IF検証環境移送リクエスト承認
  EVNT_GRP_IF_020_206 = "413", // 【無名】IF検証環境移送リクエスト否認
  EVNT_GRP_IF_020_208 = "414", // 【無名】IF検証環境移送リクエスト破棄
  EVNT_GRP_IF_020_216 = "415", // 【無名】移送処理対象IF検証移送チケットをロックする
  EVNT_GRP_IF_020_217 = "416", // 【無名】リトライ回数規定内でIF検証移送失敗時
  EVNT_GRP_IF_020_219 = "417", // 【無名】IF検証移送のリトライ移送時
  EVNT_GRP_IF_020_220 = "418", // 【無名】リトライ回数規定超過でIF検証移送失敗時
  EVNT_GRP_IF_020_222 = "419", // 【無名】IF検証移送成功時
  EVNT_GRP_IF_020_224 = "420", // 【無名】IF検証環境移送を引戻する
  EVNT_GRP_IF_020_230 = "421", // 【無名】IF検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_IF_030_201 = "422", // 【無名】IF定義本番環境移送チケット更新
  EVNT_GRP_IF_030_202 = "423", // 【無名】IF要件明細の本番環境移送リクエストレビュー依頼
  EVNT_GRP_IF_030_203 = "424", // 【無名】IF要件明細の本番環境移送リクエスト承認
  EVNT_GRP_IF_030_204 = "425", // 【無名】IF要件明細の本番環境移送リクエスト否認
  EVNT_GRP_IF_030_205 = "426", // 【無名】IF要件明細の本番環境移送リクエスト破棄
  EVNT_GRP_IF_030_209 = "427", // 【無名】IF本番移送処理対象としてロックする
  EVNT_GRP_IF_030_210 = "428", // 【無名】リトライ回数規定内でIF本番移送失敗時
  EVNT_GRP_IF_030_211 = "429", // 【無名】IF本番移送のリトライ移送時
  EVNT_GRP_IF_030_212 = "430", // 【無名】リトライ回数規定超過でIF本番移送失敗時
  EVNT_GRP_IF_030_213 = "431", // 【無名】IF本番移送成功時
  EVNT_GRP_IF_030_214 = "432", // 【無名】IF本番環境移送を引戻する
  EVNT_GRP_IF_030_217 = "433", // 【無名】IF本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PJ_020_024 = "434", // 【無名】IFプロジェクト自動完了
  EVNT_GRP_PJ_030_013 = "500", // 無名コンポーネントプロジェクト起票
  EVNT_GRP_PJ_030_014 = "501", // 無名コンポーネントプロジェクト開始宣言
  EVNT_GRP_PJ_030_015 = "502", // 【無名】コンポーネント設計チケット作成
  EVNT_GRP_PJ_030_016 = "503", // 【無名】コンポーネント検証移送チケット作成
  EVNT_GRP_PJ_030_017 = "504", // 【無名】コンポーネント本番移送チケット作成
  EVNT_GRP_PJ_020_023 = "505", // 【無名】コンポーネントプロジェクト手動完了
  EVNT_GRP_PT_010_012 = "506", // 【無名】Component設計チケット更新
  EVNT_GRP_PT_020_201 = "507", // 【無名】Component検証移送チケット更新
  EVNT_GRP_PT_020_202 = "508", // 【無名】Component検証環境移送リクエストレビュー依頼
  EVNT_GRP_PT_020_203 = "509", // 【無名】Component検証環境移送リクエスト承認
  EVNT_GRP_PT_020_204 = "510", // 【無名】Component検証環境移送リクエスト否認
  EVNT_GRP_PT_020_205 = "511", // 【無名】Component検証環境移送リクエスト破棄
  EVNT_GRP_PT_020_209 = "512", // 【無名】Component検証環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_020_210 = "513", // 【無名】リトライ回数規定内でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_262 = "514", // 【無名】Component検証環境移送リトライ移送時
  EVNT_GRP_PT_020_211 = "515", // 【無名】リトライ回数規定超過でComponent検証環境移送の移送失敗時
  EVNT_GRP_PT_020_212 = "516", // 【無名】Component検証環境移送の移送成功時
  EVNT_GRP_PT_020_213 = "517", // 【無名】Component検証環境移送承認後に承認を引戻する
  EVNT_GRP_PT_020_216 = "518", // 【無名】Component検証環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PT_030_201 = "519", // 【無名】Component本番移送チケット更新
  EVNT_GRP_PT_030_202 = "520", // 【無名】Component本番環境移送リクエストレビュー依頼
  EVNT_GRP_PT_030_203 = "521", // 【無名】Component本番環境移送リクエスト承認
  EVNT_GRP_PT_030_204 = "522", // 【無名】Component本番環境移送リクエスト否認
  EVNT_GRP_PT_030_205 = "523", // 【無名】Component本番環境移送リクエスト破棄
  EVNT_GRP_PT_030_209 = "524", // 【無名】Component本番環境移送リクエスト処理対象としてロックする
  EVNT_GRP_PT_030_210 = "525", // 【無名】リトライ回数規定内でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_211 = "526", // 【無名】Component本番環境移送リトライ移送時
  EVNT_GRP_PT_030_212 = "527", // 【無名】リトライ回数規定超過でComponent本番環境移送の移送失敗時
  EVNT_GRP_PT_030_213 = "528", // 【無名】Component本番環境移送の移送成功時
  EVNT_GRP_PT_030_214 = "529", // 【無名】Component本番環境移送承認後に承認を引戻する
  EVNT_GRP_PT_030_217 = "530", // 【無名】Component本番環境移送が移送失敗の断面でリトライする
  EVNT_GRP_PJ_020_025 = "531", // 【無名】コンポーネントプロジェクト自動完了
  EVNT_GRP_PT_010_000 = "532", // Component設計開始
  EVNT_GRP_PT_010_013 = "533", // Component設計を実行待ちへ戻す
  EVNT_GRP_PT_020_023 = "534", // Component STG移送チケットを実行待ちへ戻す
  EVNT_GRP_PT_030_024 = "535", // Component PRD移送チケットを実行待ちへ戻す
  EVNT_GRP_PT_040_002 = "536", // STGインフラ構築チケット作成:DIPインフラ
  EVNT_GRP_PT_040_003 = "537", // STGインフラ構築チケット作成:業務APP
  EVNT_GRP_PT_040_004 = "538", // STGインフラ構築チケット作成:業務インフラ
  EVNT_GRP_PT_040_102 = "539", // STGインフラ構築チケット実行:DIPインフラ
  EVNT_GRP_PT_040_103 = "540", // STGインフラ構築チケット実行:業務APP
  EVNT_GRP_PT_040_104 = "541", // STGインフラ構築チケット実行:業務インフラ
  EVNT_GRP_PT_040_202 = "542", // STGインフラ構築チケット完了:DIPインフラ
  EVNT_GRP_PT_040_203 = "543", // STGインフラ構築チケット完了:業務APP
  EVNT_GRP_PT_040_204 = "544", // STGインフラ構築チケット完了:業務インフラ
  EVNT_GRP_PT_040_302 = "545", // STGインフラ構築チケットキャンセル:DIPインフラ
  EVNT_GRP_PT_040_303 = "546", // STGインフラ構築チケットキャンセル:業務APP
  EVNT_GRP_PT_040_304 = "547", // STGインフラ構築チケットキャンセル:業務インフラ
  EVNT_GRP_PT_050_002 = "548", // 副STGインフラ構築チケット作成:DIPインフラ
  EVNT_GRP_PT_050_003 = "549", // 副STGインフラ構築チケット作成:業務APP
  EVNT_GRP_PT_050_004 = "550", // 副STGインフラ構築チケット作成:業務インフラ
  EVNT_GRP_PT_050_102 = "551", // 副STGインフラ構築チケット実行:DIPインフラ
  EVNT_GRP_PT_050_103 = "552", // 副STGインフラ構築チケット実行:業務APP
  EVNT_GRP_PT_050_104 = "553", // 副STGインフラ構築チケット実行:業務インフラ
  EVNT_GRP_PT_050_202 = "554", // 副STGインフラ構築チケット完了:DIPインフラ
  EVNT_GRP_PT_050_203 = "555", // 副STGインフラ構築チケット完了:業務APP
  EVNT_GRP_PT_050_204 = "556", // 副STGインフラ構築チケット完了:業務インフラ
  EVNT_GRP_PT_050_302 = "557", // 副STGインフラ構築チケットキャンセル:DIPインフラ
  EVNT_GRP_PT_050_303 = "558", // 副STGインフラ構築チケットキャンセル:業務APP
  EVNT_GRP_PT_050_304 = "559", // 副STGインフラ構築チケットキャンセル:業務インフラ
  EVNT_GRP_PT_060_002 = "560", // PRDインフラ構築チケット作成:DIPインフラ
  EVNT_GRP_PT_060_003 = "561", // PRDインフラ構築チケット作成:業務APP
  EVNT_GRP_PT_060_004 = "562", // PRDインフラ構築チケット作成:業務インフラ
  EVNT_GRP_PT_060_102 = "563", // PRDインフラ構築チケット実行:DIPインフラ
  EVNT_GRP_PT_060_103 = "564", // PRDインフラ構築チケット実行:業務APP
  EVNT_GRP_PT_060_104 = "565", // PRDインフラ構築チケット実行:業務インフラ
  EVNT_GRP_PT_060_202 = "566", // PRDインフラ構築チケット完了:DIPインフラ
  EVNT_GRP_PT_060_203 = "567", // PRDインフラ構築チケット完了:業務APP
  EVNT_GRP_PT_060_204 = "568", // PRDインフラ構築チケット完了:業務インフラ
  EVNT_GRP_PT_060_302 = "569", // PRDインフラ構築チケットキャンセル:DIPインフラ
  EVNT_GRP_PT_060_303 = "570", // PRDインフラ構築チケットキャンセル:業務APP
  EVNT_GRP_PT_060_304 = "571", // PRDインフラ構築チケットキャンセル:業務インフラ
  EVNT_GRP_IF_020_024 = "572", // 検証移送チケットを初期ステータスに戻す
  EVNT_GRP_IF_020_025 = "573", // 検証移送チケットを初期ステータスに戻す
  EVNT_GRP_IF_020_026 = "574", // 検証移送チケットを初期ステータスに戻す
  EVNT_GRP_IF_020_027 = "575", // 検証移送チケットを初期ステータスに戻す
  EVNT_GRP_PJ_010_011 = "576", // プロジェクト計画完了後の再見積もり
  EVNT_GRP_PJ_020_004 = "577", // プロジェクト計画完了
  EVNT_GRP_PJ_020_005 = "578", // プロジェクト開始前の要件変更
  EVNT_GRP_PJ_020_006 = "579", // プロジェクト開始後の要件変更
  EVNT_GRP_PJ_020_007 = "580", // 要件変更後の再度プロジェクト開始宣言
  EVNT_GRP_IF_010_018 = "581", // 設計レビュー中からの要件再確定により再設計
  EVNT_GRP_IF_010_021 = "584", // 設計中からの要件再確定によりチケットキャンセル
  EVNT_GRP_IF_020_232 = "587", // 要件再確定によりチケット不要でキャンセル
  EVNT_GRP_IF_020_233 = "588", // 要件再確定により再移送が必要でWaitingへ
  EVNT_GRP_IF_030_218 = "590", // 要件再確定によりチケット不要でキャンセル
  EVNT_GRP_IF_030_219 = "591", // 要件再確定により再移送が必要でWaitingへ
  EVNT_GRP_PJ_010_012 = "593", // 再見積もりを行うため、PJT計画チケットを見積作成中に戻す(予算取得中)
  EVNT_GRP_PJ_010_013 = "594", // 再見積もりを行うため、PJT計画チケットを見積作成中に戻す(プロジェクト計画承認中)
  EVNT_GRP_PJ_020_026 = "595", // Src IF属性入力チケット作成
  EVNT_GRP_PJ_020_027 = "596", // Dst IF属性入力チケット作成
  EVNT_GRP_PJ_020_028 = "597", // IF検証移送チケット作成
  EVNT_GRP_PJ_020_029 = "598", // IF本番移送チケット作成
  EVNT_GRP_IF_030_024 = "599", // 再見積もりを行うため、PJT計画チケットを見積作成中に戻す(予算取得中)
  EVNT_GRP_IF_030_025 = "600", // IF属性が承認済から設計レビュー中に引き戻されたため、本番移送チケットをWaitingに戻す
  EVNT_GRP_IF_030_026 = "601", // IF属性が承認済から設計中に引き戻されたため、本番移送チケットをWaitingに戻す
  EVNT_GRP_IF_030_027 = "602", // IF属性が承認済から設計レビュー中に引き戻されたため、本番移送チケットをWaitingに戻す
  EVNT_GRP_IF_030_028 = "603", // IF属性が承認済から設計中に引き戻されたため、本番移送チケットをWaitingに戻す
  EVNT_GRP_PT_020_025 = "604", // Component STG移送チケットをキャンセルへ変更
  EVNT_GRP_PT_030_026 = "605", // Component PRD移送チケットをキャンセルへ変更
  EVNT_GRP_PJ_010_014 = "608", // 見積結果確認し承認、予算不要のため予算確保はスキップ
  EVNT_GRP_PJ_010_015 = "609", // プロジェクト計画却下し、予算取得をスキップした場合に見積内容確認中に戻す
}
